export const ALLOWED_PATHS = ['/lea', '/customers', '/point_of_contacts', '/customer_asset'];
